import script from "./Step3.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3.vue?vue&type=script&setup=true&lang=js"

import "./Step3.vue?vue&type=style&index=0&id=7208b058&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7208b058"]])

export default __exports__